import { useCallback, useEffect, useState } from 'react'
import { useGetLogoPresignedUrlMutation } from 'store/task-automation/task-automation.api'
import { getUserId } from 'utils/common'

/**
 * Fetches the user company logo for display and PDF export.
 * Prefers inline dataUrl from the API so html2canvas can embed the logo in saved PDFs.
 */
export function useUserCompanyLogo(enabled = true) {
  const userId = getUserId()
  const [logoUrl, setLogoUrl] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [getLogoPresignedUrl] = useGetLogoPresignedUrlMutation()

  const fetchLogo = useCallback(async () => {
    if (!userId) {
      setLogoUrl('')
      return
    }

    setIsLoading(true)
    try {
      const response = await getLogoPresignedUrl({ user_id: userId }).unwrap()
      const dataUrl = response.dataUrl?.trim()
      const presignedUrl = response.presignedUrl?.trim()
      setLogoUrl(dataUrl || presignedUrl || '')
    } catch (error) {
      console.error('Error fetching logo:', error)
      setLogoUrl('')
    } finally {
      setIsLoading(false)
    }
  }, [getLogoPresignedUrl, userId])

  useEffect(() => {
    if (!enabled) {
      setLogoUrl('')
      return
    }
    fetchLogo()
  }, [enabled, fetchLogo])

  return { logoUrl, isLoading, refetchLogo: fetchLogo }
}
